import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import ProductContext from '@/product/context/product/productContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommentContext from '@/product/context/comment/commentContext'
import * as Yup from 'yup'
import { handleRedirectInternal, mapData } from '@/product/common/components'
import ReplyComments from './ReplyComments'
import AuthContext from '@/product/context/auth/authContext'
import Layout from '@/product/components/templates/Layout'
import DynamicListing from '../Listing/dynamicListing'
import './Comments.css'
import ManageComments from './manageComments'

const QuestionAnswer = (props) => {
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)

    const { user } = useContext(AuthContext)

    const {
        all_comments,
        getAllComments,
        saveComment,
        responseStatus: replyCommentsResponse,
        clearResponse: clearComment,
    } = useContext(CommentContext)
    const [disable, setDisable] = useState(false)

    const history = useHistory()
    const { setAlert } = alertContext

    const data = props.data
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryId: 0,
        projectType: 0,
    })
    const toggleFullScreenPopup = (
        popup,
        status,
        id,
        secondaryID,
        projectType
    ) => {
        if (popup) {
            console.log('toggleFullScreenPopup', popup, status, id, projectType)
            setManage({ popup, status, id, secondaryID, projectType })
        } else {
            setManage({ popup, status: 'new', id: 0, secondaryID: 0 })
        }
    }

    const [commentsManage, setCommentsManage] = useState({
        popup: false,
        status: 'new',
        secondaryId: 0,
        id: 0,
    })
    const toggleFullScreenCommentsPopup = (popup, status, id, secondaryId) => {
        if (popup) {
            setCommentsManage({ popup, status, id, secondaryId: secondaryId })
        } else {
            if (props && props?.match?.params?.id) {
                handleRedirectInternal(history, 'questions_answers')
            }
            setCommentsManage({ popup, status: 'new', id: 0, secondaryId: 0 })
        }
    }

    const [manageAuction, setManageAuction] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })

    const toggleFullScreenPopupAuction = (popup, status, id, projectType) => {
        if (popup) {
            setManageAuction({ popup, status, id, projectType })
        } else {
            setManageAuction({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const [tableAllBody, setTableAllBody] = useState({
        records: [],
        totalRecords: 0,
        setDisp: '',
    })
    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            answered: '',
            filters: true,
            project_id: 0,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            console.log(values, 'what is ')
            getAllComments(values, 'outsidePage')
        },
    })

    useEffect(() => {
        console.log('all_comments ', all_comments)
        if (all_comments.from === 'outsidePage') {
            if (all_comments) {
                setTableBody(
                    all_comments.records.length ? all_comments.records : []
                )
            }
            setTableAllBody(all_comments)
            setIsLoading(false)
        }
    }, [all_comments])

    const resetFrom = () => {
        formik.setValues({
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project_id: 0,
        })
        formik.handleReset()
        setIsLoading(false)
    }

    const onClickAuction = (id, secondaryID) => {
        // toggleFullScreenPopupAuction(true, 'edit', id, 12)
        // console.log(id, secondaryID, 'sttyyy')
        // window.open(
        //     `${process.env.REACT_APP_FRONTEND_URL}productView/${secondaryID}`,
        //     '_blank',
        //     'noopener,noreferrer'
        // )
        handleRedirectInternal(history, `listing/edit/${secondaryID}`)
    }
    const onClickProductView = (id, secondaryID) => {
        window.open(
            `${process.env.REACT_APP_FRONTEND_URL}productView/${secondaryID}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    const onClickComment = (id, secondaryID) => {
        console.log('COOO', id, secondaryID)
        handleRedirectInternal(
            history,
            `questions_answers/${id}/${secondaryID}`
        )
        // toggleFullScreenCommentsPopup(true, 'edit', id, secondaryID)
    }

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.project_id = data?.project_id || 0
        formik.values.answered = ''
        getAllComments(formik.values, 'outsidePage')
    }, [])

    useEffect(() => {
        if (props?.match?.params?.id && props.match.params.productId) {
            onClickComment(props.match.params.id, props.match.params.productId)
        }
    }, [props])

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'answer') {
            toggleFullScreenPopup(true, type, id, secondaryID)
        } else if (type === 'new_answer') {
            formikAddComment.values.comment_id = id
            formikAddComment.values.project_id = secondaryID
            setAddCommentPopup(true)
        }
    }

    const onClickViewUser = (id, type) => {
        handleRedirectInternal(history, `users/view/${id}`)
    }

    const tableValues = [
        {
            field: 'avatar',
            type: 'imagewithurl',
            folder: 'product',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Picture',
            custom: true,
        },
        {
            field: 'project_id',
            type: 'hyperlink',
            clickID: 'id',
            firstChild: false,
            sort: false,
            disablePadding: false,
            onclick: onClickProductView,
            secondaryClickID: 'project_id',
            label: 'Lot Id',
            filterable: true,
            filterField: 'c.project_id',
        },
        {
            field: 'user_id',
            type: 'hyperlink',
            clickID: 'user_id',
            onclick: onClickViewUser,
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'User ID',
        },
        {
            field: 'users_first_name,users_last_name',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Name',
        },
        {
            field: 'projects_title',
            type: 'hyperlink',
            clickID: 'id',
            onclick: onClickAuction,
            secondaryClickID: 'project_id',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Lot Title',
            filterable: true,
            filterField: 'p.title',
        },

        {
            field: 'comment',
            type: 'hyperlink',
            clickID: 'id',
            secondaryClickID: 'project_id',
            firstChild: false,
            sort: false,
            click: true,
            onclick: onClickComment,
            clickID: 'id',
            secondaryClickID: 'project_id',
            disablePadding: false,
            label: 'Question',
        },
        {
            field: 'last_reply',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Answer',
        },

        // {
        //     field: 'email',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Email',
        // },
    ]

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            buttonType: 'open_in_new',
            clickType: 'answer',
            clickID: 'id',
            secondaryClickID: 'project_id',
            onclick: onClickAuction,
            tooltipTitle: 'Visit Auction',
        })
        actionPush.push({
            buttonType: 'visibility',
            clickType: 'answer',
            clickID: 'id',
            secondaryClickID: 'project_id',
            onclick: onClickComment,
            tooltipTitle: 'View Comment Details',
        })
        // actionPush.push({
        //     buttonType: 'add',
        //     clickType: 'new_answer',
        //     clickID: 'id',
        //     secondaryClickID: 'project_id',
        //     onclick: onClickEdit,
        //     tooltipTitle: 'Add an Answer',
        // })

        return actionPush
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickID: 'id',
        secondaryClickID: 'project_id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const [addCommentPopup, setAddCommentPopup] = useState(false)
    const changeAddCommentPopup = () => {
        setAddCommentPopup(!addCommentPopup)
    }

    const validationAddComment = Yup.object({
        comment: Yup.string().required('Required'),
    })
    const formikAddComment = useFormik({
        initialValues: {
            table: '',
            comment: '',
            comment_id: 0,
            user_id: 0,
            project_id: 0,
        },
        validationSchema: validationAddComment,
        onSubmit: (values) => {
            formikAddComment.setSubmitting(true)
            if (values.comment !== '') {
                formikAddComment.values.table = 'comments'
                formikAddComment.values.user_id = user?.admin_id || 0
                console.log('addComent ', values)
                saveComment(values)
                setDisable(true)
            }
        },
    })

    useEffect(() => {
        console.log('commentsDone ', replyCommentsResponse)
        if (
            replyCommentsResponse?.from === 'saveComment' &&
            replyCommentsResponse?.status === 'success'
        ) {
            // setAlert('Commented Successfully', replyCommentsResponse.status)
            clearComment()
            formikAddComment.values.comment = ''
            setAddCommentPopup(false)
            setIsLoading(true)
            setDisable(false)
            formik.values.page = 1
            formik.values.project_id = data?.project_id || 0
            getAllComments(formik.values, 'outsidePage')
        }
    }, [replyCommentsResponse])

    const addCommentoption = [
        {
            label: 'Answer',
            placeholder: 'Add a Answer',
            type: 'textarea',
            class: 'col-12',
            name: 'comment',
            formik: formikAddComment,
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Questions',
                placeholder: 'Select Status',
                class: `col-sm-4 col-12`,
                type: 'select',
                name: 'answered',
                options: [
                    { value: '1', show: 'Answered' },
                    { value: '0', show: 'Not Answered' },
                ],
                native: true,
            },
        ],
    }

    const closeFunction = () => {
        setAddCommentPopup(false)
        formikAddComment.values.comment = ''
    }

    return (
        <>
            <Layout>
                <div className="dashboard commentManagement">
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={tableAllBody}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getAllComments}
                        fromVariable="outsidePage"
                        hideCompactView={true}
                        columnStorageVariable={'table_view_comments'}
                    />
                </div>
                <CustomDialog
                    title={'Answer'}
                    open={addCommentPopup}
                    function={changeAddCommentPopup}
                    disableBackdropClick
                    className="commentsModal"
                >
                    <p>{'Write an answer for this question'}</p>

                    <div className="row">
                        {Object.values(mapData(addCommentoption))}
                    </div>

                    <div className="actionWrapper">
                        <Button
                            id="comment_cancel"
                            onClick={() => closeFunction()}
                        >
                            {'Cancel'}
                        </Button>
                        <PrimaryButton
                            id="comment_submit"
                            onClick={formikAddComment.handleSubmit}
                            type="button"
                            label={'Submit'}
                            disabled={disable}
                        />
                    </div>
                </CustomDialog>
                <ReplyComments data={manage} function={toggleFullScreenPopup} />
                {/* <DynamicListing
                    data={manageAuction}
                    function={toggleFullScreenPopupAuction}
                    editModaltitle={'View Listing'}
                    noSubmitBtn={true}
                    noUpdateBtn={true}
                /> */}
            </Layout>
        </>
    )
}

export default QuestionAnswer
